import { getAllowedDomains } from "@utils/EmailUtils";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnBoarding } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { api } from "~/Services";

const { Title, Text, Link } = Typography;

const allowedDomains = getAllowedDomains();

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [hasBlurred, setHasBlurred] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { openToast } = useNotification();
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const query = useQuery();
  const reset = query.get('reset')

  const validateEmail = (value: string): string => {
    const trimmed = value.trim();
    if (!trimmed) {
      return "Email is required";
    }

    if (/\s/.test(trimmed)) {
      return "Email must not contain spaces";
    }

    const allowedCharsRegex = /^[a-zA-Z0-9@_.-]+$/;
    if (!allowedCharsRegex.test(trimmed)) {
      return "Email contains invalid characters";
    }

    const isValidDomain = allowedDomains.some((domain) => value.toLowerCase().endsWith(domain));

    return isValidDomain ? "" : `Email must end with ${allowedDomains.join(" or ")}`;
  };

  useEffect(() => {
    const message = validateEmail(email);
    setIsValid(message === "");
  }, [email]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setErrorMessage("");
  };

  const handleBlur = () => {
    setHasBlurred(true);
    const message = validateEmail(email);
    setErrorMessage(message);
  };

  const handleSubmit = () => {
    const message = validateEmail(email);
    setErrorMessage(message);
    const formData = new FormData();
    formData.append("emailAddress", email);
    if (!message) {
      setIsLoading(true);
      api
        .post(`/auth/reset-initiate`, formData,{ headers: { "X-Auth-Type": "manual" } })
        .then((res) => {
          const message = res?.data?.message;
          openToast({ content: message, type: "success" });
          navigate(`/auth/forgot-password-otp?emailAddress=${email}`);
        })
        .catch((err) => {
          const message = err?.response?.data?.message;
          openToast({ content: message, type: "error" });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <OnBoarding>
      <Title level={2}>{reset==="true"?"Reset":"Forgot"} Password</Title>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Form layout="vertical">
            <Form.Item
              label="Email"
              validateStatus={hasBlurred && errorMessage ? "error" : ""}
              help={hasBlurred && errorMessage ? errorMessage : ""}
            >
              <Input
                placeholder="Enter your email"
                value={email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={isLoading}
                type="primary"
                onClick={handleSubmit}
                disabled={!isValid}
                size="large"
                block
                style={{ marginTop: 20 }}
              >
                Send OTP
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Row>
        {reset==="true"?(null):(<><Col span={24}>
          <Text>Remember password?</Text>
          <Link onClick={() => navigate("/auth/login")}> Go Back to Login</Link>
        </Col></>)}
      </Row>
    </OnBoarding>
  );
};
